import type { FunctionComponent } from "react";
import TableManualKeyboard from "@/react/core/TableManualKeyboard.tsx";
import { inputController0 } from "@/react/core/Input.tsx";
import { useComputed, useSignal } from "@/react/core/reactive.ts";
import { LL0 } from "@/react/core/I18nService.tsx";
import Autocomplete from "@/react/core/Autocomplete.tsx";
import { makeRipple } from "@/react/core/ripple-utils.ts";
import { deviceSetting0 } from "@/data/DeviceSettingSignal.ts";
import { userFLow } from "@/shared/logger.ts";
import { order0 } from "@/react/OrderView/OrderViewShare.ts";
import { loginUser } from "@/data/UserSignal.ts";
import { highlightText } from "@/react/KioskOrderView/KioskOrderView.tsx";
import {
  filtersDelivery,
  onlineOrders1,
  setFiltersDelivery, setFilterV
} from "@/react/DeliveryManagementView/DeliveryManagementLogic.tsx";
import _ from "lodash";
import type { ProductLayout } from "@/data/ProductLayout.ts";
import { toast } from "react-toastify";

export type OrderScreenSearchItemType = {
  className?: string;
  onClose?: () => void;
  onConfirm?: (result: any) => void
};

const SearchCustomer: FunctionComponent<OrderScreenSearchItemType> = ({
  className = "",
  onClose,
}) => {
  const [searchText, setSearchText] = useSignal<string>('');
  const [customerName, setCustomerName] = useSignal<string>('');
  const [selectedResult, setSelectedResult] = useSignal<any>(undefined)

  const filteredResults = useComputed(() => {
    console.log('trigger ', searchText())
    return (
      searchText()
        ? onlineOrders1().filter(o => o.customerRaw?.name?.toLowerCase()?.includes(searchText()?.toLowerCase()))
        : onlineOrders1()
    ) || []
  })
  console.log('filteredResults ', filteredResults())
  const filteredResultsName = useComputed(() => {
    const uniqueOrders = new Map();

    filteredResults().forEach(order => {
      const name = order.customerRaw?.name || '';
      if (!uniqueOrders.has(name)) {
        uniqueOrders.set(name, {
          name,
          customer: order.customerRaw!,
          order,
          displayName: name
        });
      }
    });

    return Array.from(uniqueOrders.values());
  });

  function autoCompleteProps() {
    return {
      id: "combo-box-service",
      freeSolo: true,
      className: "flex-1",
      value: searchText(), // ?
      filterOptions: (opts: any) => opts,
      onChange: (e: any, v: any) => { //trigger when press x icon
        if (!v) {
          console.log('reset')
          setSearchText('')
          setCustomerName('')
          setSelectedResult(undefined)
        }
      },
      options: filteredResultsName(),
      getOptionLabel: (option: string | { id: string, name: string, displayName: string } | null) => {
        if (!option) return '';
        return typeof option === 'string' ? option : (option.displayName || '');
      },
      inputValue: searchText() || customerName(),
      inputProps: {
        caretClass: '!w-[2px] !h-[24px] !bg-[#747980]',
        textClass: '!text-[#747980] !font-serif text-[24px]',
        label: '',
        value: searchText(),
        onChange: (value: any) => {
          console.log('inputValue ', value)
          const inputValue = value || '';
          setSearchText(inputValue)
          setCustomerName(inputValue)
        },
        className: "w-full font-mulish text-[22px] !text-[#747980]  border-2 rounded-[1000px] bg-[#fff] border-[#b0b0b0] border-[1.5px] border-solid box-border h-[56px] flex flex-row items-center justify-start py-[4px] px-[24px] gap-[8px] pl-[40px]"
      },
      renderOption: ({ style, className, ...restProps }, option, state) => {
        return (
          <li className="self-stretch box-border flex flex-row items-center justify-between py-2 px-2 relative border-b-[2px] border-solid border-gray-solid-gray-164-e1e1e1"
              key={option.id}
              {...restProps}
              onClick={(e) => {
                console.log('click option ', option)
                setSelectedResult(option.order)
                setSearchText(option.displayName)
                setCustomerName(option.displayName)
                restProps.onClick?.(e);
              }}
          >
            <div className="text-left flex-1 relative z-[1] font-serif text-[#747980] mq950:text-[20px]">
              <span>{highlightText(option.displayName, searchText())}</span>
            </div>
          </li>
        )
      },
    }
  }

  return (
    <div
      className={`w-[600px] h-[550px] rounded-[8px] relative bg-white-solid-white-100-ffffff flex flex-col items-start justify-start pt-4 px-4 pb-2 box-border gap-[24px] max-w-full max-h-full overflow-auto text-left text-base text-blue-solid-blue-500-0051c1 font-mulish ${className}`}
    >
      <img
        className="w-6 absolute !m-[0] top-[12px] right-[12px] h-6 object-cover cursor-pointer z-[10]"
        alt=""
        src="/icong-close-popup-icon--grey12@2x.png"
        onClick={onClose}
      />
      <div className="self-stretch flex-1 flex flex-col items-start justify-start gap-[11px] z-[0]">
        <div className="font-bold text-[16px] text-[#0051c1]">
          {LL0().deliveryManagement.searchCustomerInformation()}
        </div>
        <div
          className="self-stretch flex flex-1 flex-row items-start justify-start gap-[2px] text-sm text-black-solid-black-900-1e1e23">
          <Autocomplete {...autoCompleteProps()} />
        </div>
      </div>
      {deviceSetting0()?.useVirtualKeyboard &&
        <div className="self-stretch flex flex-row items-center justify-end z-[1] text-center text-sm text-white-solid-white-100-ffffff">
          <div
            className="self-stretch rounded-md bg-blue-solid-blue-420-2979ff overflow-hidden flex flex-row items-center justify-center py-[9px] px-8"
            ref={makeRipple}
            onClick={() => {
              userFLow(`confirm search customer`, {
                username: loginUser()?.name
              });
              if (!selectedResult()) {
                toast.warning('please select an option!')
                return
              }
              console.log('confirm search ', selectedResult())
              const currentFilters = filtersDelivery();
              currentFilters.searchCustomer = {orderId: selectedResult()._id, customer: selectedResult()?.customerRaw}
              setFiltersDelivery(currentFilters);
              setFilterV(p => p + 1)
              onClose?.()
            }}
          >
            <b className="relative">{LL0().ui.ok()}</b>
          </div>
        </div>
      }
      {!deviceSetting0()?.useVirtualKeyboard &&
        <TableManualKeyboard
          inputController={inputController0}
          onEnter={() => {
            if (!selectedResult()) {
              toast.warning('please select an option!')
              return
            }
            console.log('confirm search ', selectedResult())
            const currentFilters = filtersDelivery();
            currentFilters.searchCustomer = {orderId: selectedResult()._id, customer: selectedResult()?.customerRaw}
            setFiltersDelivery(currentFilters);
            setFilterV(p => p + 1)
            onClose?.()
          }}
        />}
    </div>
  );
};

export default SearchCustomer;
